import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppConstants } from '../../../shared/constants/constants';
import { IEditJobModel } from '../modal/job-details-edit.model';
import { IOfficeSelectorModel } from '../modal/office-selector-model';


@Injectable()
export class JobsServicesService {

  private BASE_URL = this.appconstants.API_BASE_URL_JOB;
  private API_BASE_URL_DIRECT_JOB = this.appconstants.API_BASE_URL_DIRECT_JOB;


  constructor(private http: HttpClient, private appconstants: AppConstants) { }

  LockAndUnLockJob(data): Observable<any> {
    const options = new HttpParams()
      .set('lockJob', data.lockJob)
      .set('App', 'SalesWeb')
      .set('allowLockOverride', data.allowLockOverride);    // override can only be true when 'Locked by another user' dialog was displayed

    return this.http.post(this.BASE_URL + '/' + data.drAddressId + '/Jobs/' + data.jobId, data, { params: options })
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  // SalesOffices Get OfficeSelector
  getOfficeSelector() {
    return this.http.get<IOfficeSelectorModel[]>(this.BASE_URL + '/Jobs/SalesOffices')
      .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
  }

  fetchJobDetails(jobId, drAddressId): Observable<IEditJobModel> {
    return this.http.get<IEditJobModel>(this.BASE_URL + '/' + drAddressId + '/Jobs/' + jobId);
  }

  /**
   * Get resourse url of the document that is moved to share point
   * @param- job id -Job id for which going to fetch shipping instruction.
   * @param- drAddressId - Against this dr address id we are going to execute the query.
   * @param- documentKey -Document Key
   * @param- documentVersion - Document version
   * @param- documentStorage - Document storage location
   */
  downloadDocument(drAddressId: number, jobId: number, documentKey: string, documentVersion: string,
    documentStorage: string): Observable<{ file: Blob }> {
    const options = new HttpParams().set('documentKey', documentKey).set('documentVersion', documentVersion)
      .set('documentStorage', documentStorage);
    const url = `${this.API_BASE_URL_DIRECT_JOB}/${drAddressId}/Jobs/${jobId}/Document/Download`;
    return this.http.get(url, { observe: 'response', responseType: 'blob', params: options })
      .pipe(map((res) => {
        return {
          file: new Blob([res.body], { type: res.headers.get('Content-Type') }),
        };

      }), catchError((error: HttpErrorResponse) => throwError(error)));
  }
}
